import React, { useState, useEffect } from "react";
import fastimg from "../../../images/fastImg.png";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { Link } from "react-router-dom";
import question from "../../../images/question.png";
import FastParity from "../fast/fastparity/FastParity";
import axios from "axios";
import "./FastParityTap.css";
import Parity from "../fast/parity/Parity";
import Rule from "./fastparity/Rule";
import Rule1 from "./parity/Rule1";
const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:focus": {
      outline: "none",
    },
  },

  paper: {
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    border: "none",
    flexDirection: "column",
    width:"100%",
    height: "500px",
    overflowY: "scroll",
    padding: "20px",
    top: "13.5%",
    alignItems: "center",
    boxShadow: theme.shadows[5],

    "&:focus": {
      outline: "none",
    },

    position: "relative",
    borderRadius: "10px",
  },
}));
const FastParityTap = () => {
  const classes = useStyles();
  const [toggleState, setToggleState] = useState(1);
  const [paritydata, setparitydata] = useState("");
  const [fastdata, setfastdata] = useState("");
  const [creategame, setcreategame] = useState(false);
  const [creategame1, setcreategame1] = useState(false);
  const [biddatafast, setbiddatafast] = useState("");
  const [biddataparity, setbiddataparity] = useState("");
  const [resultfast, setresultfast] = useState("");
  const [resultparity, setresultparity] = useState("");
  const [showrule, setshowrule] = useState(1);
  const [disable, setdisable] = useState(false);
  const [run, setrun] = useState(false);
  const [open, setopen] = useState(false);

  const handleOpen = () => {
    setopen(true);
  };

  const handleClose = () => {
    setopen(false);
  };
  axios.defaults.headers.get["Authorization"] = `Bearer ${localStorage.getItem(
    "tokenAuth"
  )}`;

  const everyoneorderfast = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/everyonesOrder/fastparity`
    );

   
  };
  const everyoneorderparity = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/everyonesOrder/parity`
    );

    
  };
  const creategam = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/createGame/SumitAkhil@122812`
    );

   
  };

  //result - history
  const resulthistoryfast = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/fastparity/result-history`
    );


    setresultfast(response.data.data);
    console.log("fast result",resultfast)
  };

  const resulthistoryparity = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/parity/result-history`
    );


    setresultparity(response.data.data);
  };

  //bid history

  const bidhistoryfast = async () => {
    const response = await axios.get(
      "https://v1.fiewin.luckywin999.in/api/fastparity/bid-game-history "
    );

   
    setbiddatafast(response.data.data);
  };

  const bidhistoryparity = async () => {
    const response = await axios.get(
      "https://v1.fiewin.luckywin999.in/api/parity/bid-game-history "
    );

    setbiddataparity(response.data.data);

    
  };
  ///get time apis
  const gettimefast = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/fastparity/games`
    );

    if (response.data) {
      setfastdata(() => response.data);
    }
     
    console.log("fast create game",response)
  };

  const gettimeparity = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/parity/games`
    );

    if (response.data) {
      setparitydata(() => response.data);
    }
   
  };

  useEffect(() => {
    gettimefast();
    bidhistoryfast();
    everyoneorderfast();
    resulthistoryfast();
    setdisable(false);
  }, [run]);

  const toggleTab = (index) => {
    setToggleState(index);
    if (index === 1) {
      gettimefast();
      bidhistoryfast();
      resulthistoryfast();
      setshowrule(1);
      setparitydata("");
      setdisable(false);
      if (creategame === true) {
        console.log("30");
        creategam();
        gettimefast();
      }
    }
    if (index === 2) {
      gettimeparity();
      bidhistoryparity();
      everyoneorderparity();
      resulthistoryparity();
      setshowrule(2);
      setfastdata("");
      setbiddatafast("");
      setdisable(false);
      if (creategame1 === true) {
        console.log("180");
        creategam();
        gettimeparity();
      }
    }
  };

  return (
    <>
      <div>
        <Modal
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              {showrule === 1 && <Rule  handleClose={handleClose}/>}
              {showrule === 2 && <Rule1 handleClose={handleClose}/>}
            </div>
          </Fade>
        </Modal>
      </div>
      <div className="mobilewidth">
        <div className="container1">
          <div className="bloc-tabs1">
            <div className="center-arrow2">
              <Link to="/fiewin">
                <ArrowBackIosIcon style={{ cursor: "pointer" }} />
              </Link>
            </div>
            <button
              className={toggleState === 1 ? "tabs2 " : "tabs1"}
              onClick={() => toggleTab(1)}
            >
              <img className="fasti" src={fastimg} alt="fast" />
              Fast-Parity
            </button>
            <button
              className={toggleState === 2 ? "tabs2 " : "tabs1"}
              onClick={() => toggleTab(2)}
            >
              Parity
            </button>
            <div onClick={handleOpen} className="rule-left1">
              <img src={question} alt="question" />{" "}
              <span className="ruleleft"> Rule</span>
            </div>
          </div>

          <div className="content-tabs">
            <div
              className={
                toggleState === 1 ? "content  active-content" : "content"
              }
            >
              <FastParity
                data={fastdata}
                setcreategame={setcreategame}
                creategam={creategam}
                gettimefast={gettimefast}
                biddatafast={biddatafast}
                bidhistoryfast={bidhistoryfast}
                resultfast={resultfast}
                setdisable={setdisable}
                disable={disable}
                resulthistoryfast={resulthistoryfast } 
              />
            </div>

            <div
              className={
                toggleState === 2 ? "content  active-content" : "content"
              }
            >
              <Parity
                data={paritydata}
                setcreategame1={setcreategame1}
                creategam={creategam}
                gettimeparity={gettimeparity}
                biddataparity={biddataparity}
                bidhistoryparity={bidhistoryparity}
                resultparity={resultparity}
                setdisable={setdisable}
                disable={disable}
                resulthistoryparity={resulthistoryparity}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FastParityTap;
